import { z } from "zod";

export const billingCreditIssuePayloadSchema = z.object({
  customer: z.string().min(1),
  account_tier: z.string().min(1).optional(),
  amount: z.number().positive(),
  currency: z.enum(["USD", "EUR", "GBP", "ILS"]),
  invoice: z.string().min(1),
  reason: z.string().min(1)
});

export type BillingCreditIssuePayload = z.infer<typeof billingCreditIssuePayloadSchema>;
